import React from 'react';
import ContentViewComponent from '../../../../Component/ContentViewComponent/ContentViewComponent';
import TableComponent from '../../../../Component/TableComponent/TableComponent';
import ApiHandler from '../../../../Handler/ApiHandler';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { getRoutePathname } from '../../../../Handler/RouteHandler';
import { IconButton, Tooltip } from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';
import Swal from "sweetalert2";
import { TableReload } from '../../../../Reducer/TableReducer/TableSlice';
import { dispatch } from '../../../../App';
import { SnackbarOpen } from '../../../../Reducer/SnackBarReducer/SnackBarSlice';

function ProductList() {
    const [loading, setLoading] = React.useState(true);
    const [breadcrumbs, setBreadcrumbs] = React.useState({});
    const navigate = useNavigate();

    const columns = [
        {
            name: "id",
            label: "Référence",
            options: { filter: true, sort: true }
        },
        {
            name: "label",
            label: "Libellé",
            options: { filter: true, sort: true }
        },
        {
            name: "price",
            label: "Prix (€)",
            options: { filter: true, sort: true }
        },
        {
            name: "createdAt",
            label: "Date de création",
            options: { filter: true, sort: true }
        },
        {
            name: "updatedAt",
            label: "Date de modification",
            options: { filter: true, sort: true }
        },
        {
            name: "action",
            label: "Action",
            options: { filter: false, sort: false }
        }
    ];

    React.useEffect(() => {
        setBreadcrumbs({
            title: 'Configuration',
            context: 'Produits',
            description: '',
            links: []
        });

        setTimeout(() => {
            setLoading(false);
        }, 1200);
    }, []);

    const getAction = (row) => {
        return (
            <div style={{ display: 'flex' }}>
                <Tooltip title={"Éditer"} placement="left" arrow>
                    <IconButton onClick={() => navigate(getRoutePathname('configuration_product', { id: row.id }))}>
                        <Edit />
                    </IconButton>
                </Tooltip>
                <Tooltip title={"Supprimer"} placement="left" arrow>
                    <IconButton
                        onClick={() => {
                            Swal.fire({
                                title: "Êtes-vous sûr de vouloir supprimer ce produit ?",
                                icon: "warning",
                                showCancelButton: true,
                                confirmButtonColor: "#87bba4",
                                cancelButtonColor: "var(--greytext)",
                                confirmButtonText: "Confirmer",
                                cancelButtonText: "Annuler",
                                reverseButtons: true,
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    ApiHandler.delete(
                                        {
                                            route: "configuration_product_delete",
                                            params: { id: row.id },
                                        },
                                        (response) => {
                                            if (response.status === 200) {
                                                dispatch(TableReload("configuration_product_list"));
                                                dispatch(
                                                    SnackbarOpen({
                                                        text: "Produit supprimé avec succès",
                                                        variant: "success",
                                                    }),
                                                );
                                            } else {
                                                dispatch(
                                                    SnackbarOpen({
                                                        text:
                                                            response.error && response.error.message
                                                                ? response.error.message
                                                                : "Une erreur inattendu s'est produite.",
                                                        variant: "error",
                                                    }),
                                                );
                                            }
                                        },
                                    );
                                }
                            });
                        }}
                    >
                        <Delete />
                    </IconButton>
                </Tooltip>
            </div>
        );
    };

    return (
        <ContentViewComponent loading={loading} breadcrumbs={breadcrumbs}>
            <TableComponent
                id={'configuration_product_list'}
                title={'Produits'}
                columns={columns}
                mobileMode={'cards'}
                actionFirst={{
                    label: "Ajouter un produit",
                    onClick: () => { navigate(getRoutePathname('configuration_product', { id: 'add' })); },
                }}
                promiseData={(resolve) => {
                    ApiHandler.get({ route: 'configuration_product_list' },
                        (response) => {
                            if (response.status === 200) {
                                let data = response.data;
                                for (let index in data) {
                                    data[index].action = getAction(data[index]);
                                    data[index].createdAt = data[index].createdAt ? moment(data[index].createdAt).format('ll') : '-';
                                    data[index].updatedAt = data[index].updatedAt ? moment(data[index].updatedAt).format('ll') : '-';
                                    data[index].price = !Number.isNaN(Number(data[index].price))
                                        ? Number(data[index].price).toFixed(2)
                                        : '-';
                                }
                                resolve(data);
                            } else {
                                resolve([]);
                            }
                        });
                }}
            />
        </ContentViewComponent>
    );
}

export default ProductList;
